import { getDeviceId } from '@/lib/device-id'

/**
 * Headers for the sign-up and sign-in requests to our backend.
 *
 * `X-Device-Id` is this browser install's id (the one Phoenix presence and
 * push already use). The backend counts sign-up and sign-in attempts per IP,
 * per device and per email (VAPT 2026-10 §6.4); sending it lets a device that
 * retries too often be told so on its own, instead of only by its IP, which a
 * whole office may share.
 */
export function authRequestHeaders(extra: Record<string, string> = {}): Record<string, string> {
  return { ...extra, 'X-Device-Id': getDeviceId() }
}
